<template>
    <div>
        <vx-card title="Contacts" subtitle="Lists of Contact References"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewContactReferences()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeContactReferences">
                    <template slot="thead">
                        <vs-th>Contact Name</vs-th>
                        <vs-th>Designation</vs-th>
                        <vs-th>Tel No</vs-th>
                        <vs-th>Mobile No</vs-th>
                        <vs-th>Company</vs-th>
                        <vs-th>Company Address</vs-th>
                        <vs-th>Line Of Business</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].contactName">
                                {{ data[indextr].contactName }}
                            </vs-td>
                            <vs-td :data="data[indextr].designation">
                                {{data[indextr].designation}}
                            </vs-td>
                            <vs-td :data="data[indextr].telephoneNo">
                                {{data[indextr].telephoneNo}}
                            </vs-td>
                            <vs-td :data="data[indextr].mobileNo">
                                {{data[indextr].mobileNo}}
                            </vs-td>
                            <vs-td :data="data[indextr].companyName">
                                {{data[indextr].companyName}}
                            </vs-td>
                            <vs-td :data="data[indextr].companyAddress">
                                {{data[indextr].companyAddress }}
                            </vs-td>
                            <vs-td :data="data[indextr].lineOfBusinessId">
                                {{lineOfBusinessName(data[indextr].lineOfBusinessId).lineOfBusinessName }}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD CONTACT INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Contacts"
                accept-text= "Submit"
                @accept="onAddContactReferences"
                :is-valid="validForm"
                :active.sync="activePromptNewContactReferences">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Name</span><span style="color:red">*</span>
                         <vs-input v-validate="'alpha_spaces|max:50'" name="contact name" class="w-full" v-model="contactName" placeholder="Name" />
                         <span class="text-danger text-sm" v-show="errors.has('contact name')">{{ errors.first('contact name') }}</span>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Designation</span><span style="color:red">*</span>
                        <vs-input name="designation-name" class="w-full" v-model="designation" placeholder="Designation"  />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Mobile No</span><span style="color:red">*</span>
                        <vs-input v-validate="'max:11|numeric'" name="mobile no" class="w-full" v-model="mobileNo" placeholder="11-digit mobile no"/>
                        <span class="text-danger text-sm" v-show="errors.has('mobile no')">{{ errors.first('mobile no') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Telephone No</span>
                        <vs-input name="telno" class="w-full" v-model="telephoneNo" placeholder="(02) 8888 88 88"/>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company</span><span style="color:red">*</span>
                        <vs-input name="company-name" class="w-full" v-model="company" placeholder="Company"  />

                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Address</span>
                        <vs-input name="designation-name" class="w-full" v-model="companyAddress" placeholder="Company Address" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Line Of Business</span><span style="color:red">*</span>
                        <v-select name="lob-name" v-model="lineOfBusiness" label="lineOfBusinessName" :options="getAllLineOfBusinessLookup" placeholder="Please Select"  />

                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT CONTACT INFORMATION -->
            <vs-prompt
                class="email-compose"
                title="Contacts"
                accept-text= "Submit"
                @accept="onEditContactReferences"
                :is-valid="validForm"
                :active.sync="activePromptEditContactReferences">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Name</span><span style="color:red">*</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="contact name" class="w-full" v-model="contactName" placeholder="Name" />
                         <span class="text-danger text-sm" v-show="errors.has('contact name')">{{ errors.first('contact name') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Designation</span><span style="color:red">*</span>
                        <vs-input name="designation-name" class="w-full" v-model="designation" placeholder="Designation"  />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-input v-validate="'max:11|numeric'" name="mobile no" class="w-full" v-model="mobileNo" placeholder="11-digit mobile no"/>
                        <span class="text-danger text-sm" v-show="errors.has('mobile no')">{{ errors.first('mobile no') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Telephone No</span>
                        <vs-input name="telno" class="w-full" v-model="telephoneNo" placeholder="(02) 8888 88 88"/>
                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company</span><span style="color:red">*</span>
                        <vs-input name="company-name" class="w-full" v-model="company" placeholder="Company"  />

                    </div>
                </div>
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Company Address</span>
                        <vs-input name="designation-name" class="w-full" v-model="companyAddress" placeholder="Company Address" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Line Of Business</span><span style="color:red">*</span>
                        <v-select name="lob-name" v-model="lineOfBusiness" label="lineOfBusinessName" :options="getAllLineOfBusinessLookup" placeholder="Please Select"  />

                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>


            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            contactName         : '',
            birthdate           : null,
            designation         : '',
            mobileNo            : '',
            company             : '',
            telephoneNo         : '',
            companyAddress      : '',
            lineOfBusiness      : [],
            acquintanceHistory  : '',
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewContactReferences    : false,
            activePromptEditContactReferences    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            // this.$store.dispatch('hrms/getAllContactReferences', { userId : null})
            this.$vs.loading()
            this.$store.dispatch('lookup/getAllLineOfBusinessLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeContactReferences = this.uid
            //  this.$store.dispatch('hrms/getAllContactReferences',  this.uid )
            
    },
    computed: {
        employeeContactReferences: {
           
           get() { return this.$store.state.hrms.employeeContactReferences },
           set(value) { this.$store.dispatch('hrms/getAllContactReferences',  value )}
            
        },
        validForm(){
           return this.contactName != '' && this.designation !='' && this.lineOfBusiness.lineOfBusinessId != null && this.mobileNo != '' &&
                this.company != ''
        },
        getAllLineOfBusinessLookup() {
            return this.$store.state.lookup.getAllLineOfBusinessLookup
        },
        getRank() {
             return this.$store.state.lookup.getAllRankLookup
        },
        lineOfBusinessName() {
            return (id) => this.$store.getters['lookup/lineOfBusinessLookup'](id)
        },
    },
    methods: {
        promptAddNewContactReferences() {
            this.activePromptNewContactReferences = true
        },
        onAddContactReferences() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    contactName: this.contactName,
                    designation : this.designation,
                    telephoneNo: this.telephoneNo,
                    mobileNo: this.mobileNo,
                    companyName: this.company,
                    companyAddress: this.companyAddress,
                    lineOfBusinessId : this.lineOfBusiness.lineOfBusinessId,
                    birthdate: this.birthdate,
                    acquintanceHistory: this.acquintanceHistory,
                    remarks: this.remarks,
                    userId: this.uid,
                    currentUserId: this.$store.state.AppActiveUser.uid
                }

                this.$store.dispatch('hrms/AddContactReferences', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
            // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditContactReferences() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    const data = {
                        id                  : this.id,
                        contactName         : this.contactName,
                        designation         : this.designation,
                        telephoneNo         : this.telephoneNo,
                        mobileNo            : this.mobileNo,
                        companyName         : this.company,
                        companyAddress      : this.companyAddress,
                        lineOfBusinessId    : this.lineOfBusiness.lineOfBusinessId,
                        birthdate           : this.birthdate,
                        acquintanceHistory  : this.acquintanceHistory,
                        remarks             : this.remarks,
                        userId              : this.uid,
                        currentUserId       : this.$store.state.AppActiveUser.uid
                    }
                    this.$store.dispatch('hrms/UpdateContactReferences', data)
                        .then(response => {
                                this.$vs.loading.close()
                                this.$vs.notify({
                                title: 'Success',
                                text: 'Contacts Updated',
                                iconPack: 'feather',
                                icon: 'icon-alert-circle',
                                color: 'success'                  
                                })
                        })
                        .catch(error => {
                                this.$vs.loading.close()
                                this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                        })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeContactReferences'](Id)
            this.id                  = e.id,
            this.contactName         = e.contactName,
            this.designation         = e.designation,
            this.telephoneNo         = e.telephoneNo,
            this.mobileNo            = e.mobileNo,
            this.company             = e.companyName,
            this.companyAddress      = e.companyAddress,
            this.lineOfBusiness      = this.lineOfBusinessName(e.lineOfBusinessId),
            this.birthdate           = e.birthdate,
            this.acquintanceHistory  = e.acquintanceHistory,
            this.remarks             = e.remarks
            this.userId              = e.userId

            this.activePromptEditContactReferences = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteContactReferences', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeContactReferences = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Contacts Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>